import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { FC } from 'react';
import { RadioButton, RadioButtonProps } from './RadioButton';
import { cn } from '@fe-learner-common';

interface RadioGroupProps extends Omit<RadioButtonProps, 'value'> {
  items: { key: string; label: string }[];
  ariaLabel: string;
  selected: string;
  onValueChange: (value: string) => void;
}

export const RadioButtonGroup: FC<RadioGroupProps> = ({
  id,
  size,
  items,
  ariaLabel,
  selected,
  onValueChange,
}) => {
  const handleOnChange = (value: string) => {
    if (value !== selected) {
      onValueChange(value);
    }
  };

  return (
    <RadioGroupPrimitive.Root
      className="lf:flex lf:flex-col"
      defaultValue={selected}
      value={selected}
      aria-label={ariaLabel}
      onValueChange={onValueChange}
    >
      {items.map((item) => {
        const itemId = `radio-button-${id}-option-${item.key}`;
        return (
          <div
            onClick={() => handleOnChange(item.key)}
            key={itemId}
            className="lf:flex lf:h-12 lf:cursor-pointer lf:items-center lf:gap-2 lf:rounded-lg lf:p-3.5 lf:pe-3 lf:hover:bg-neutral-100"
          >
            <RadioButton value={item.key} size={size} id={itemId} />
            <label
              onClick={(e) => e.preventDefault()}
              className={cn('lf:cursor-pointer lf:text-title-sm lf:leading-none', {
                'lf:text-neutral-500': selected !== item.key,
              })}
              htmlFor={itemId}
            >
              {item.label}
            </label>
          </div>
        );
      })}
    </RadioGroupPrimitive.Root>
  );
};
